export const toInch = (cm) => Math.floor(parseInt(cm) * 0.3937 * 100) / 100;
